import React, {useCallback, useContext} from 'react';

import {ActionWithReasonButton} from 'src/components/save-with-reason/action-with-reason-button';
import {MessageContext} from 'src/contexts/message-context';
import {useAdminAccessRight} from 'src/hooks/access-rights';

import {useRestoreUser} from './useRestoreUser';

import type {ActionWithReason} from 'src/components/save-with-reason/action-with-reason-button';

type Props = {
    userId: number,
    accountId: number,
    onDone: () => void,
};

export const RestoreUser = ({userId, accountId, onDone}: Props) => {
    const {setSuccessMessage} = useContext(MessageContext);
    const {canDeleteUser} = useAdminAccessRight();
    const onSuccess = useCallback(() => {
        setSuccessMessage('User is successfully restored');
        onDone();
    }, [onDone, setSuccessMessage]);
    const {event, busy} = useRestoreUser({userId, onSuccess});
    const onConfirm = useCallback<ActionWithReason>(async options => (await event(options)) || undefined, [event]);

    return canDeleteUser(accountId) ? (
        <ActionWithReasonButton
            action="Restore"
            variant="Type.SECONDARY"
            colorVariant="ACCENT"
            busy={busy}
            onConfirm={onConfirm}
            confirmation={{
                title: 'Restore User',
                message: 'Are you sure you want to restore this user?',
                width: 320,
            }}
        />
    ) : null;
};
